import { FundOverviewView } from "@/features/S2Dashboard";

export default function FundOverviewPage() {
  return <FundOverviewView />;
}
